export default __webpack_public_path__ + "static/media/gameplay-icon-7.991b62d9.gif";